import { Cell } from 'src/components/organisms/DataTable/types';

interface ObjectWithId {
    id: string | number;
    rowId?: string | number;
}

export function findRow<T extends ObjectWithId>(cell: Cell, originalData: T[], simulationData: T[]) {
    const rowIndexToUpdate = originalData.findIndex(matchRow(cell));
    const simulationIndexToUpdate = simulationData.findIndex(matchRow(cell));

    const currentData =
        rowIndexToUpdate >= 0 ? originalData[rowIndexToUpdate] : simulationData[simulationIndexToUpdate];

    return {
        rowIndexToUpdate,
        simulationIndexToUpdate,
        currentData,
    };
}

export function matchRow<T extends ObjectWithId>(cell: Cell) {
    return (x: T) => {
        const cellRowIdAsNumber = Number(cell.rowId);
        const rowHasValidRowId = x.rowId !== null && x.rowId !== undefined && !Number.isNaN(Number(x.rowId));

        if (rowHasValidRowId && !Number.isNaN(cellRowIdAsNumber)) {
            return Number(x.rowId) === cellRowIdAsNumber;
        }

        const idAsNumber = Number(x.id);
        const canMatchById = !Number.isNaN(idAsNumber) && !Number.isNaN(cellRowIdAsNumber);

        return canMatchById && idAsNumber === cellRowIdAsNumber;
    };
}
